import * as Zod from 'zod';

export const buildingScheme = Zod.object({
  id: Zod.number(),
  title: Zod.string(),
  complexId: Zod.number(),
});
